// ============================================================
//  Compare Slider Divider Line
//  Add to: Assets/compare-images.js (at the bottom)
//  OR create a new snippet: Assets/compare-slider-line.js
//  and load it in theme.liquid before </body>:
//    <script src="{{ 'compare-slider-line.js' | asset_url }}" defer></script>
// ============================================================

(function () {
  function initCompareLines() {
    document.querySelectorAll(".compare").forEach(function (c) {
      // Avoid adding duplicate lines if script runs twice
      if (c.querySelector(".compare-divider-line")) return;

      var l = document.createElement("div");
      l.className = "compare-divider-line";
      l.style.cssText =
        "position:absolute;top:0;bottom:0;width:5px;" +
        "background:rgba(255,255,255,0.5);pointer-events:none;" +
        "z-index:4;left:50%;transform:translateX(-50%)";
      c.appendChild(l);

      var input  = c.querySelector(".compare__input");
      var btn    = c.querySelector(".compare__btn");
      if (!input || !btn) return;

      function update() {
        var w   = c.offsetWidth;
        var bw  = btn.offsetWidth;
        var pct = (input.value / 100 * (w - bw) + bw / 2) / w * 100;
        l.style.left = pct + "%";
      }

      input.addEventListener("input", update);
      update();
    });
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCompareLines);
  } else {
    initCompareLines();
  }

  // Also run after a short delay to catch any sliders that load late
  setTimeout(initCompareLines, 800);
})();
